/* tslint:disable */
/* eslint-disable */
/**
 * TurboClaim API
 * TurboClaim API for insurance claim management. Includes claims, documents, estimates, supplements, billing, and chat operations. Authentication is JWT-based bearer token. 
 *
 * The version of the OpenAPI document: 1.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UpdateClaimAccess200ResponseData
 */
export interface UpdateClaimAccess200ResponseData {
    /**
     * 
     * @type {number}
     * @memberof UpdateClaimAccess200ResponseData
     */
    id: number;
    /**
     * 
     * @type {number}
     * @memberof UpdateClaimAccess200ResponseData
     */
    claimId: number;
    /**
     * 
     * @type {string}
     * @memberof UpdateClaimAccess200ResponseData
     */
    principalType: UpdateClaimAccess200ResponseDataPrincipalTypeEnum;
    /**
     * 
     * @type {number}
     * @memberof UpdateClaimAccess200ResponseData
     */
    principalId: number;
    /**
     * 
     * @type {string}
     * @memberof UpdateClaimAccess200ResponseData
     */
    accessLevel: UpdateClaimAccess200ResponseDataAccessLevelEnum;
    /**
     * 
     * @type {Array<string>}
     * @memberof UpdateClaimAccess200ResponseData
     */
    blockedModules: Array<UpdateClaimAccess200ResponseDataBlockedModulesEnum>;
    /**
     * 
     * @type {number}
     * @memberof UpdateClaimAccess200ResponseData
     */
    grantedByUserId: number;
}


/**
 * @export
 */
export const UpdateClaimAccess200ResponseDataPrincipalTypeEnum = {
    User: 'user',
    Company: 'company'
} as const;
export type UpdateClaimAccess200ResponseDataPrincipalTypeEnum = typeof UpdateClaimAccess200ResponseDataPrincipalTypeEnum[keyof typeof UpdateClaimAccess200ResponseDataPrincipalTypeEnum];

/**
 * @export
 */
export const UpdateClaimAccess200ResponseDataAccessLevelEnum = {
    Ro: 'ro',
    Rw: 'rw'
} as const;
export type UpdateClaimAccess200ResponseDataAccessLevelEnum = typeof UpdateClaimAccess200ResponseDataAccessLevelEnum[keyof typeof UpdateClaimAccess200ResponseDataAccessLevelEnum];

/**
 * @export
 */
export const UpdateClaimAccess200ResponseDataBlockedModulesEnum = {
    Comparisons: 'comparisons',
    Documents: 'documents',
    Photos: 'photos',
    Links: 'links',
    Tasks: 'tasks',
    Supplements: 'supplements',
    Forms: 'forms',
    Financials: 'financials',
    Emails: 'emails',
    Notes: 'notes'
} as const;
export type UpdateClaimAccess200ResponseDataBlockedModulesEnum = typeof UpdateClaimAccess200ResponseDataBlockedModulesEnum[keyof typeof UpdateClaimAccess200ResponseDataBlockedModulesEnum];


/**
 * Check if a given object implements the UpdateClaimAccess200ResponseData interface.
 */
export function instanceOfUpdateClaimAccess200ResponseData(value: object): value is UpdateClaimAccess200ResponseData {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('claimId' in value) || value['claimId'] === undefined) return false;
    if (!('principalType' in value) || value['principalType'] === undefined) return false;
    if (!('principalId' in value) || value['principalId'] === undefined) return false;
    if (!('accessLevel' in value) || value['accessLevel'] === undefined) return false;
    if (!('blockedModules' in value) || value['blockedModules'] === undefined) return false;
    if (!('grantedByUserId' in value) || value['grantedByUserId'] === undefined) return false;
    return true;
}

export function UpdateClaimAccess200ResponseDataFromJSON(json: any): UpdateClaimAccess200ResponseData {
    return UpdateClaimAccess200ResponseDataFromJSONTyped(json, false);
}

export function UpdateClaimAccess200ResponseDataFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateClaimAccess200ResponseData {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'claimId': json['claimId'],
        'principalType': json['principalType'],
        'principalId': json['principalId'],
        'accessLevel': json['accessLevel'],
        'blockedModules': json['blockedModules'],
        'grantedByUserId': json['grantedByUserId'],
    };
}

export function UpdateClaimAccess200ResponseDataToJSON(json: any): UpdateClaimAccess200ResponseData {
    return UpdateClaimAccess200ResponseDataToJSONTyped(json, false);
}

export function UpdateClaimAccess200ResponseDataToJSONTyped(value?: UpdateClaimAccess200ResponseData | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'claimId': value['claimId'],
        'principalType': value['principalType'],
        'principalId': value['principalId'],
        'accessLevel': value['accessLevel'],
        'blockedModules': value['blockedModules'],
        'grantedByUserId': value['grantedByUserId'],
    };
}

